import jApi from './jApi';

export default {
  getListDataConnectivity(params) {
    const api = jApi.generateApi();
    return api.get('/nocode/jdc/fetch', { params })
      .then(res => res);
  },

  setDataConnectivity(params) {
    const api = jApi.generateApi();
    return api.post('/nocode/jdc/set', params)
      .then(res => res.data);
  },

  deleteDataConnectivity(params) {
    const api = jApi.generateApi();
    return api.delete('/nocode/jdc/delete', { params })
      .then(res => res.data);
  },

  verifyDataConnectivity(params) {
    const api = jApi.generateApi();
    return api.post('/nocode/jdc/verify', params)
      .then(res => res.data);
  },
};



// WEBPACK FOOTER //
// ./src/services/jApiDataConnectivity.js